/// <amd-module name="Artifacts/Root/containers/TabTitleUpdater" />
import { IRootModuleState } from "Artifacts/Root/redux/Contracts";
import * as Res from "Artifacts/Root/Resources";
import { IFeed } from "Artifacts/Root/types";
import * as React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import * as StringUtils from "VSS/Core/Util/String";

interface ITabTitleProps {
  tabTitle?: string;
}

interface ITabTitleUpdaterMapStateToProps {
  feed?: IFeed;
}

const TabTitleUpdater: React.FC<ITabTitleUpdaterMapStateToProps & ITabTitleProps> = ({
  tabTitle,
  feed,
}) => {
  useEffect(() => setDefaultPageTitle(tabTitle ? tabTitle : feed ? feed.name : ""), [
    feed,
    tabTitle,
  ]);
  return null;
};

/**
 * Sets page title using the default page title format
 */
export function setDefaultPageTitle(title: string): void {
  document.title = getDefaultPageTitle(title);
}

/**
 * Gets page title using the default page title format
 */
function getDefaultPageTitle(title: string): string {
  return StringUtils.format(
    Res.PageTitle_PlaceHolder,
    title || Res.PageTitle_PlaceHolder_FeedsDefault,
  );
}

const mapStateToProps = (state: IRootModuleState): ITabTitleUpdaterMapStateToProps => {
  return {
    feed: state.rootState.feed,
  };
};

const ConnectedTabTitleUpdater = connect(mapStateToProps)(TabTitleUpdater);

export { ConnectedTabTitleUpdater as TabTitleUpdater };
